export const PLAY_URL = 'https://play.google.com/store/apps/details?id=com.brainappsvilles.idcardswallts';
export const APP_ICON =
  'https://play-lh.googleusercontent.com/OjKoK3PHZfEJrFeyjvwyc35qD91zJiKDE3jlaCdgdHWCN6O9V3GU9fSh_wMl3kr7kq11l5zq4ubmSf-eKFbf9A=s256';
export const DEV_SITE = 'https://innoapps.site';
export const DEV_EMAIL = 'innoapps313@gmail.com';
export const SITE = 'https://idcardwallet.innoapps.site';

const shot = (id: string, w = 540) => `https://play-lh.googleusercontent.com/${id}=w${w}`;

/** Real screenshots from the Google Play listing (hotlinked). */
export const SCREENSHOTS = {
  organise: shot('LyOFkzbFq9Vmd55P-Do7HtKDzpxwBhOLA_oorSMRQzOI5lrgauvcstoJDjxTUTUaxE2PaqoK9b40JMkHHsDl'),
  saved: shot('cFs4kneeUyMNYTWG8okI3QIFTSgqQU2X1beo9Q-lOmm8wTeE0TtN8hL7Q3O561tYTnNSNYd9Vsjy8fcduYow'),
  files: shot('3A6Go-S3s340E-yks4v0QTysUxymt_miImRYOCR5sB0GMuk34pcF3fvoJfJwraeYXYU1KptewVoXwg8F_vbmrz0'),
  pin: shot('uEQKwFczfmiUaYKA2GYNQVXtSiHDNqvnul94WyByJCEU4VA-Nz7dE3jviHMCAow2ZrXIMmmkkvNOmoP3ZhbD'),
  importFiles: shot('RCRsgnLbvJoZFgFtAVYrGq80m-y8lPK-yIV46FaghtboG281VCKfpp2TnRno5O0HAuPMz36SwjloTYYnLEcO1d4'),
  cardInfo: shot('AzFgbMymBrbLP1aypfPW7DOFxjdNp-mfmoJJeGhMAsfMZ4UZEq7N_SHXapu9meNP86Lq70snj6LQNgr6sfse4x8'),
  watchA: shot('mDCNQNeSJJYe2fp_32itNLlwWyIG6yd2v8z8jy8wy5a-f29OqMXn3qRWwQc-TuKbwAEEtX1D6yUCTRUjDcw6PH0', 454),
  watchB: shot('Ydme9YamQ224q6ONEH3-ZICuBuXh2Loc7qkBtLDGMVKV84se-0u7IyNHyAwfOU4XJsG2T8qCo8COXACjc3YhcQ', 454),
};

export const SCREENSHOT_LIST: { src: string; title: string; caption: string }[] = [
  { src: SCREENSHOTS.organise, title: 'Organise cards', caption: 'Cards sorted into categories with a count on each.' },
  { src: SCREENSHOTS.saved, title: 'Saved cards', caption: 'Search, favourite and filter the cards in a category.' },
  { src: SCREENSHOTS.cardInfo, title: 'Card info', caption: 'Front, back and the details you typed in, on one screen.' },
  { src: SCREENSHOTS.pin, title: 'PIN code', caption: 'The app opens only after your PIN.' },
  { src: SCREENSHOTS.files, title: 'Stored files', caption: 'Documents and PDFs kept next to your cards.' },
  { src: SCREENSHOTS.importFiles, title: 'Import files', caption: 'Add new documents from your phone.' },
];

export const PLAY_FACTS = {
  rating: '5.0',
  downloads: '50K+',
};
